// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3isfa","log":"ModalInventoryLogs_log__2FRWJ","date":"ModalInventoryLogs_date__3fSzQ","userName":"ModalInventoryLogs_userName__3AzYo"};